import styled from 'styled-components';

export const StyledPaperLayout = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  .selector {
    border: 4px solid ${(props) => props.theme.colors.primaryColor};
    background: rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
  }
  .StyledPaperLayout_Row {
    &_Container {
      flex: 1 1 auto;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }

  canvas {
    background: ${(props) => props.theme.colors.white};
  }
`;

export const Selected = styled.div`
  border: ${(props) => (props.selected ? '5px solid #47A2FF' : '5px solid black')};
`;
